var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    fill: "#008638",
    stroke: "#039E44",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.21875C19.0625 7.53125 19.0625 8 18.75 8.28125L10.5 16.5312C10.2188 16.8438 9.75 16.8438 9.46875 16.5312L5.21875 12.2812C4.90625 12 4.90625 11.5312 5.21875 11.2188C5.5 10.9375 5.96875 10.9375 6.25 11.2188L10 14.9688L17.7188 7.21875C18 6.9375 18.4688 6.9375 18.75 7.21875Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.deb275b0abb54fe88710d00ad5c3888f.svg";
export { ForwardRef as ReactComponent };